import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettings = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13.625 8C13.625 7.8275 13.6175 7.6625 13.6025 7.49L14.9975 6.4325C15.2975 6.2075 15.38 5.7875 15.1925 5.4575L13.79 3.035C13.6025 2.705 13.1975 2.57 12.8525 2.72L11.24 3.4025C10.9625 3.2075 10.67 3.035 10.3625 2.8925L10.145 1.16C10.1 0.785 9.77749 0.5 9.40249 0.5H6.60499C6.22249 0.5 5.89999 0.785 5.85499 1.16L5.63749 2.8925C5.32999 3.035 5.03749 3.2075 4.75999 3.4025L3.14749 2.72C2.80249 2.57 2.39749 2.705 2.20999 3.035L0.807493 5.465C0.619993 5.795 0.702493 6.2075 1.00249 6.44L2.39749 7.4975C2.38249 7.6625 2.37499 7.8275 2.37499 8C2.37499 8.1725 2.38249 8.3375 2.39749 8.51L1.00249 9.5675C0.702493 9.7925 0.619993 10.2125 0.807493 10.5425L2.20999 12.965C2.39749 13.295 2.80249 13.43 3.14749 13.28L4.75999 12.5975C5.03749 12.7925 5.32999 12.965 5.63749 13.1075L5.85499 14.84C5.89999 15.215 6.22249 15.5 6.59749 15.5H9.39499C9.76999 15.5 10.0925 15.215 10.1375 14.84L10.355 13.1075C10.6625 12.965 10.955 12.7925 11.2325 12.5975L12.845 13.28C13.19 13.43 13.595 13.295 13.7825 12.965L15.185 10.5425C15.3725 10.2125 15.29 9.8 14.99 9.5675L13.595 8.51C13.6175 8.3375 13.625 8.1725 13.625 8ZM8.02999 10.625C6.58249 10.625 5.40499 9.4475 5.40499 8C5.40499 6.5525 6.58249 5.375 8.02999 5.375C9.47749 5.375 10.655 6.5525 10.655 8C10.655 9.4475 9.47749 10.625 8.02999 10.625Z",
		fill: "black",
		fillOpacity: .87
	})]
});
const ForwardRef = forwardRef(SvgSettings);
export { ForwardRef as ReactComponent };
